import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { registerSW } from "virtual:pwa-register";
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";

import "../excalidraw-app/sentry";

import ExcalidrawApp from "./App";
import { BoardsListPage } from "./components/plbx/pages/BoardsListPage";
import { ApiKeysPage } from "./components/plbx/pages/ApiKeysPage";
import { PlbxStyles } from "./components/plbx/components/PlbxStyles";
import { PlbxBoardTitle } from "./components/plbx/components/PlbxBoardTitle";

window.__EXCALIDRAW_SHA__ = import.meta.env.VITE_APP_GIT_SHA;
const rootElement = document.getElementById("root")!;
const root = createRoot(rootElement);
registerSW();

root.render(
  <StrictMode>
    <PlbxStyles />
    <PlbxBoardTitle />
    <BrowserRouter>
      <Routes>
        <Route path="/boards" element={<BoardsListPage />} />
        <Route path="/account/api-keys" element={<ApiKeysPage />} />
        <Route path="/account" element={<Navigate to="/account/api-keys" replace />} />
        {/* Default route: stock canvas. Must be last. */}
        <Route path="*" element={<ExcalidrawApp />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>,
);
